/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerEnrollment } from '../../models/partner-enrollment';
import { UpdatePodosoftEnrollmentDto } from '../../models/update-podosoft-enrollment-dto';

export interface PodosoftEnrollmentControllerUpdateEnrollment$Params {
      body: UpdatePodosoftEnrollmentDto
}

export function podosoftEnrollmentControllerUpdateEnrollment(http: HttpClient, rootUrl: string, params: PodosoftEnrollmentControllerUpdateEnrollment$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerEnrollment>> {
  const rb = new RequestBuilder(rootUrl, podosoftEnrollmentControllerUpdateEnrollment.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerEnrollment>;
    })
  );
}

podosoftEnrollmentControllerUpdateEnrollment.PATH = '/api/podosoft/enrollment';
